import { createAsyncThunk } from '@reduxjs/toolkit';
import * as lodash from 'lodash';
import getUnenhancedOpenPurchase from '../selectors/getUnenhancedOpenPurchase';

const updateMiamSelections = createAsyncThunk(
  'updateMiamSelections',
  async (
    data: { miam?: MiamStagedPurchase; key: string },
    { getState, rejectWithValue },
  ) => {
    try {
      const state = getState() as EntireFrontendState;
      const openPurchase = getUnenhancedOpenPurchase(state);
      if (!openPurchase) throw new Error('Open purchase not found.');
      const { miam, key } = data;
      const { choiceSelections, miamQuantityMap } = openPurchase;
      if (data) {
        const miamSelections = lodash.get(lodash.get(miam, key), 'selections');
        let _miamQuantityMap = lodash.mapValues(miam, 'quantity');

        if (
          lodash.isEmpty(_miamQuantityMap) ||
          !(_miamQuantityMap || {})[key]
        ) {
          if (!miamQuantityMap || miamQuantityMap[key] === undefined) {
            _miamQuantityMap[key] = 1;
          } else {
            _miamQuantityMap = { ...miamQuantityMap };
          }
        }
        const newSelections = { ...choiceSelections, ...miamSelections };
        return {
          purchase: {
            ...openPurchase,
            miamQuantityMap: _miamQuantityMap,
            choiceSelections: newSelections,
          },
        };
      } else return { purchase: openPurchase };
    } catch (e) {
      console.debug('Update miam selections failed');
      rejectWithValue(e);
    }
  },
);

export default updateMiamSelections;
